// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e778d429","38":"5fb62a5e","777":"14250941"}[chunkId] + ".chunk.js";
};